import remarkGfm from "remark-gfm";
import remarkHtml from "remark-html";
import remarkParse from "remark-parse";
import { unified } from "unified";

export function convertMarkdownToHtml(markdown: string): string {
  const cleanedMarkdown = markdown
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<div>/gi, "")
    .replace(/<\/div>/gi, "")
    .replace(/<p>/gi, "")
    .replace(/<\/p>/gi, "\n\n")
    .trim();

  const processor = unified()
    .use(remarkParse)
    .use(remarkGfm)
    .use(remarkHtml, { sanitize: false });

  const result = processor.processSync(cleanedMarkdown);
  return String(result);
}

// `isLikelyHtml` lives in html-detect.util.ts so light consumers (e.g. format-compat)
// don't transitively import the ESM-only remark/unified packages, which Jest cannot parse.
// Re-exported here to preserve the existing `import { isLikelyHtml } from "utils/markdown.utils"`.
export { isLikelyHtml } from "./html-detect.util";
